import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { process, State, CompositeFilterDescriptor,AggregateDescriptor, aggregateBy } from '@progress/kendo-data-query';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { TotalSalesHomeDashVM, TotalSalesHomeDashStockVM } from '../../interfaces/interfaces';

@Component({
  selector: 'app-general-overview',
  templateUrl: './general-overview.component.html',
  styleUrls: ['./general-overview.component.scss']
})
export class GeneralOverviewComponent implements OnInit {
  public sales: any;
  public selectedTabIndex = 0;
  dateForm: UntypedFormGroup;
  yearForm: UntypedFormGroup;
  currentYear: number = new Date().getFullYear();
  isLoading = false;
  canEdit = true;
  userName: string;

  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };

  public gridStateTab1: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateTab2: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateTab3: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateTab4: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateTab5: State = {
    sort: [],
    skip: 0,
    take: 100,
  };

  tab1: TotalSalesHomeDashVM[] = [];
  tab2: TotalSalesHomeDashVM[] = [];
  tab3: TotalSalesHomeDashVM[] = [];
  tab4: TotalSalesHomeDashVM[] = [];
  tab5: TotalSalesHomeDashStockVM[] = [];

  //public gridDataTab1: any = process(this.tab1, this.gridStateTab1);
  public gridDataTab1: GridDataResult = {
    data: [],
    total: 0
  };
  public gridDataTab2: any = process(this.tab2, this.gridStateTab2);
  public gridDataTab3: any = process(this.tab3, this.gridStateTab3);
  public gridDataTab4: any = process(this.tab4, this.gridStateTab4);
  public gridDataTab5: any = process(this.tab5, this.gridStateTab5);

  public aggregatesTab1: AggregateDescriptor[] = [
    { field: "salesCurrent", aggregate: "sum" },
    { field: "salesLY", aggregate: "sum" },
  ];
  public aggregatesTab2: AggregateDescriptor[] = [
    { field: "creams", aggregate: "sum" },
    { field: "mh", aggregate: "sum" },
    { field: "dishd", aggregate: "sum" },
    { field: "cart", aggregate: "sum" },
    { field: "totalSales", aggregate: "sum" },
  ];
  public aggregatesTab3: AggregateDescriptor[] = [
    { field: "dineInSales", aggregate: "sum" },
    { field: "deliverySales", aggregate: "sum" },
    { field: "totalSales", aggregate: "sum" },
  ];
  public aggregatesTab4: AggregateDescriptor[] = [
    { field: "transactionsCurrent", aggregate: "sum" },
    { field: "transactionsLY", aggregate: "sum" },
  ];
  public aggregatesTab5: AggregateDescriptor[] = [
    { field: "totalCost", aggregate: "sum" },
  ];

  public totalTab1Now: any = aggregateBy(this.gridDataTab1.data, this.aggregatesTab1);
  public totalTab2: any = aggregateBy(this.gridDataTab2.data, this.aggregatesTab2);
  public totalTab3: any = aggregateBy(this.gridDataTab3.data, this.aggregatesTab3);
  public totalTab4: any = aggregateBy(this.gridDataTab4.data, this.aggregatesTab4);
  public totalTab5: any = aggregateBy(this.gridDataTab5.data, this.aggregatesTab5);

  constructor(
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.initializeForms();
  }
  

  ngOnInit(): void {
    this.userName = localStorage.getItem('currentUserName');
    this.loadCreamsSales();
  }

  private initializeForms(): void {
    this.yearForm = this.formBuilder.group({
      year: [this.currentYear],
    });
  }

  onYearChange(): void {
    //console.log('Year changed to:', this.yearForm.get('selectedyear').value);
    this.loadCreamsSales();
    this.cdr.detectChanges(); 
  }

  private loadCreamsSales(): void {
    this.isLoading = true;
    const selectedYear = parseInt(this.yearForm.get('year').value);
    //console.log('Selected Year:', selectedYear);

    console.log("In load");
    this.authService.getGeneralSalesDash({
      useDay: 0,
      year: selectedYear
    }).pipe(take(1)).subscribe({
      next: (response) => {
        this.sales = response;
        if (this.sales?.tab1) {
          this.gridDataTab1 = process(this.sales.tab1, this.gridStateTab1);
          if (this.gridDataTab1?.data) {
            this.totalTab1Now = aggregateBy(this.gridDataTab1.data, this.aggregatesTab1);
          }
        }
        if (this.sales?.tab2) {
          this.gridDataTab2 = process(this.sales.tab2, this.gridStateTab2);
          if (this.gridDataTab2?.data) {
            this.totalTab2 = aggregateBy(this.gridDataTab2.data, this.aggregatesTab2);
          }
        }
        if (this.sales?.tab3) {
          this.gridDataTab3 = process(this.sales.tab3, this.gridStateTab3);
          if (this.gridDataTab3?.data) {
            this.totalTab3 = aggregateBy(this.gridDataTab3.data, this.aggregatesTab3);
          }
        }
        if (this.sales?.tab4) {
          this.gridDataTab4 = process(this.sales.tab4, this.gridStateTab4);
          if (this.gridDataTab4?.data) {
            this.totalTab4 = aggregateBy(this.gridDataTab4.data, this.aggregatesTab4);
          }
        }
        if (this.sales?.tab5) {
          this.gridDataTab5 = process(this.sales.tab5, this.gridStateTab5);
          if (this.gridDataTab5?.data) {
            this.totalTab5= aggregateBy(this.gridDataTab5.data, this.aggregatesTab5);
          }
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error loading sales:', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }
  

  get selectedYear(): number {
    const year = this.yearForm?.get('year')?.value || this.currentYear;
    //console.log('Selected year:', year);
    return year;
  }

  getSafeTotal(field: string): number {
    try {
      return this.totalTab1Now?.[field]?.sum || 0;
    } catch (error) {
      console.error(`Error getting total for ${field}:`, error);
      return 0;
    }
  }
} 